import { useState } from 'react';
import { useData } from '../../contexts/data-context/use-data';
import { ErrorSection } from '../../design-system/error-section/error-section';
import { AiEnrichmentLoading } from '../../design-system/loading/ai-enrichment-loading';
import { LoadingSection } from '../../design-system/loading/loading';
import { Stack } from '../../design-system/stack/stack';
import { AccountSummarySection } from './components/accounts-summary-section';
import { TransactionTableWrapper } from './components/transaction-table-wrapper';

const TransactionsPage = () => {
  const [selectedAccountId, setSelectedAccountId] = useState<string | null>(null);
  const { data, isLoading: isLoadingData, error: dataError, meta } = useData();

  if (isLoadingData) {
    return <LoadingSection text="Loading transactions..." />;
  }

  if (!data) {
    return <ErrorSection error={dataError} />;
  }

  const { transactions, accounts, baseCurrency, categories } = data;

  return (
    <Stack align="stretch" className="min-h-screen py-2 pr-2">
      <Stack align="stretch" className="flex-1 overflow-clip rounded-md border border-border bg-background shadow-xs">
        <div className="w-full overflow-auto px-5 py-4">
          <AccountSummarySection
            accounts={accounts}
            selectedAccountId={selectedAccountId}
            baseCurrency={baseCurrency}
            onAccountSelect={setSelectedAccountId}
            onResetSelectedAccount={() => setSelectedAccountId(null)}
          />
        </div>

        {meta?.isAiEnrichmentInProgress && (
          <div className="px-4 pb-4">
            <AiEnrichmentLoading description="Our AI engine is enriching your transactions..." />
          </div>
        )}

        <TransactionTableWrapper
          accountId={selectedAccountId}
          transactions={transactions}
          accounts={accounts}
          categories={categories}
        />
      </Stack>
    </Stack>
  );
};

export default TransactionsPage;
